import { Product, ProductFeature } from "data/models";

export const STARTER_PRODUCT_KEY = "starter";

const starterPrices = {
  monthlyPrice: 100,
  annualPrice: 1100,
};

export const getStarterPrice = (cadence: "month" | "year") =>
  cadence === "year" ? starterPrices.annualPrice : starterPrices.monthlyPrice;

export const isCreditFeature = (text: string) => /\bcredits?\b/i.test(text);

export const getPlanCardFeatures = (product: Product): ProductFeature[] => {
  const creditFeatures = product.features.filter(
    (feature) =>
      isCreditFeature(feature.text) && !feature.text.startsWith("Overage"),
  );
  const premiumData = product.featureBreakdown.some(
    (feature) => feature.key === "Maps API" && feature.icon === "check",
  );
  const collaboration = product.featureBreakdown.some(
    (feature) => feature.key === "User Limit" && feature.value === "Unlimited",
  );
  const rateFeature = product.features.find((feature) =>
    /per second/i.test(feature.text),
  );
  const overageFeature = product.features.find((feature) =>
    feature.text.startsWith("Overage"),
  );

  return [
    ...creditFeatures,
    {
      icon: "check",
      text: premiumData ? "Premium data access" : "Open data access",
    },
    {
      icon: collaboration ? "check" : "info",
      text: collaboration
        ? "Collaboration included"
        : "Single user · no collaboration",
    },
    ...(rateFeature ? [rateFeature] : []),
    overageFeature ?? { icon: "info", text: "No overage available" },
  ];
};

export const getPlanDescription = (productKey: string): string | undefined => {
  const descriptions: Record<string, string> = {
    free_2025: "Explore open data",
    starter: "For individual use",
    team_2025: "For collaboration",
    professional_2025: "Higher volumes and access controls",
  };
  return descriptions[productKey];
};
